import http from "@/services/config/http-common";

export default {
    http,
    data() {
        return {
            type: "", //I ou D
            showLoadingList: false,//Sobrepõe configuração padrão se for do tipo I
        }
    },
    props: {
        typeImage: Boolean,
        typeUniqueDoc: Boolean,
        typeUniqueImage: Boolean,
        onlyView: Boolean,
        enabledTableImagesDetails: Boolean,
        categoryUnique: {
            type: String,
            default: "",
        },
        detailUnique: {
            type: String,
            default: ""
        },
        messageNotRecord: {
            type: String,
            default: "",
        },
    },
    methods: {

        mountedPrepareFormUploadDefault() {

            if (this.typeImage) {
                this.type = "I"
            } else if (this.typeUniqueImage) {
                this.type = "E"
            } else if (this.typeUniqueDoc) {
                this.type = "O"
            } else {
                this.type = "D"
            }

            if (this.type === 'D') {
                this.showLoadingList = true//Listagem de documentos irá exibir o loading normalmente
            }

            this.listParams.append("type", this.type)
            this.mountedPrepareFormListDefault();

        },

        onUploadComplete() {
            this.actionDefaultAfterCRUD()
        },

        async onItemFileDownload(foreignKey, primaryKey, nameOriginal) {

            await http.download(this.path + "/download/" + foreignKey + "/" + primaryKey, nameOriginal)
                .catch(error => this.responseError(error))

        },


    },

}


